// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// components
import { FormAddCategory } from '../../forms/FormAddCategory/FormAddCategory';

export interface DialogAddCategoryProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess: () => void;
}

export const DialogAddCategory = ({ isOpen, onClose, onSuccess }: DialogAddCategoryProps) => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState<boolean>(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('addCategory'),
					loading: isLoading,
					form: 'form-add-category',
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={700}
			onClose={onClose}
			title={{
				children: t('addCategory'),
				variant: 'h3',
			}}>
			<FormAddCategory onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
